/* eslint-disable max-len */
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Col, Row } from "../../components/StyledGridSystem";
import { UserContext } from "../../context/UserContext";
import styled from "styled-components";
import { StyledTableCell, StyledTableRow } from "../../components/Table";
import TableComponent from "../../components/Table";
import { Button, Icon, TableBody, TableHead, TableRow } from "@mui/material";
import { darken } from "polished";
import _theme from "../../styles/theme";
import LoadingSpinner from "../../components/LoadingSpinner";
import InstructorCompetencyModal from "../../components/InstructorCompetencyModal";
import { SemesterContext } from "../../context/SemesterContext";
import InstructorEvaluationModal from "../../components/InstructorEvaluationModal";
import CompetencyVersionSelect from "./competencyVersionSelect";
import { handleJWTError } from "../../hooks/jwtErrHandler";
import CheckCanvasCourseModal from "../../components/CheckCanvasCourseModal";
import { UniversityContext } from "../../context/UniversityContext";
import { getDefaultExploreProgram } from "../../utils/programName";
import AORequestsModal from "../../components/AORequestsModal";


// import Icon from "../../components/Icon";
const CustomRow = styled(Row)`
  margin-bottom: 0px;
  height: calc(100vh - 84px);
  height: -moz-calc(100vh - 84px);
  height: -o-calc(100vh - 84px);
  height: -webkit-calc(100vh - 84px);
`;
interface Column {
  id:
    | "program_name"
    | "display_version"
    | "competency_code"
    | "curriculum_version"
    | "title"
    | "credits"
    | "student_count"
    | "evaluation";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "program_name", label: "Program" },
  { id: "competency_code", label: "Competency code" },
  {
    id: "display_version",
    label: "Curriculum Version",
    minWidth: 20,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  { id: "title", label: "Competency title", minWidth: 100 },
  {
    id: "credits",
    label: "Credits",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "student_count",
    label: "Number of students",
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "evaluation",
    label: "Actions",
  },
];
function InstructorQuestsPage() {
  const [competencies, setCompetencies] = useState<Array<any>>([]);
  const [filteredCompetencies, setFilteredCompetencies] = useState<Array<any>>(
    []
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCompetency, setSelectedCompetency] = useState<{}>();

  const currentUser = useContext(UserContext).user;
  const semesterContext = useContext(SemesterContext);
  const universityContext = useContext(UniversityContext);

  const [isEvaluationOpen, setIsEvaluationOpen] = useState<boolean>(false);
  const [isCheckCanvasCourseOpen, setIsCheckCanvasCourseOpen] = useState<boolean>(false);
  const [isAORequestsOpen, setIsAORequestsOpen] = useState<boolean>(false);

  const { selectedVersionName, selectedVersion, setVersion, setVersionName } =
    useContext(UserContext);
  // const [versionOption, setVersinOption] = useState([{label:'v1. version 1', value: 1},{label:'v2 versiono 2', value:2}]);

  const competencyVersions = new Set(competencies.map((c) => c.curriculum_version));
  const allVersions = localStorage.getItem("allVersions");

  const parsedVersions = allVersions ? JSON.parse(allVersions) : [];
  const versionOption = parsedVersions
    .filter((v: any) => competencyVersions.has(v.value))
    .map((v: any) => ({
      label: String(v.label || "").replace(/^.*?:\s*/, ""),
      value: v.value,
    }));

  useEffect(() => {
    if (!semesterContext.selectedSemester?.label) return;
    fetchCompetencies(currentUser.id, currentUser.university_code);
  }, [
    currentUser,
    semesterContext.selectedSemester?.label,
    selectedVersion,
    universityContext.selectedProgram?.short_name,
  ]);

  useEffect(() => {
    if (selectedVersion !== 0) {
      filterByVersion(selectedVersion);
    }
  }, [selectedVersion]);

  useEffect(() => {
    setVersion(0); // Reset to "All"
  }, []);

  useEffect(() => {
    const programs = universityContext.programs;
    if (!programs?.length) return;
    const selected = universityContext.selectedProgram;
    const hasValidSelection =
      selected?.short_name &&
      selected.value !== "ALL" &&
      selected.label !== "ALL";
    if (!hasValidSelection) {
      universityContext.setProgram(getDefaultExploreProgram(programs));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [universityContext.programs]);

  const filterByVersion = (selectedVersion: number) => {
    const temp = competencies.filter(
      (com: any) => com.curriculum_version === selectedVersion
    );
    setFilteredCompetencies(temp);
  };
  const fetchCompetencies = (id: string, university_code: string) => {
    setLoading(true);
    axios
      .get(
        `/instructor/competencies?instructor_id=${id}&semester_name=${semesterContext.selectedSemester.label}&university_code=CMKL&program_name=${universityContext.selectedProgram?.short_name}`
      )
      .then((res) => {
        if (res.data.competency) {
          setCompetencies(res.data.competency);
        } else {
          setCompetencies([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setCompetencies([]);
        setLoading(false);
        handleJWTError(err)
      });
  };

  return (
    <>
      {selectedCompetency && (
        <InstructorCompetencyModal
          semesterName={semesterContext.selectedSemester.label}
          isOpen={isModalOpen}
          setOpen={setIsModalOpen}
          data={selectedCompetency}
        />
      )}
      {selectedCompetency && (
        <InstructorEvaluationModal
          semesterName={semesterContext.selectedSemester.label}
          semesterId={semesterContext.selectedSemester.id}
          isOpen={isEvaluationOpen}
          setOpen={setIsEvaluationOpen}
          data={selectedCompetency}
        />
      )}
      {selectedCompetency && (
        <CheckCanvasCourseModal
          semesterName={semesterContext.selectedSemester.label}
          isOpen={isCheckCanvasCourseOpen}
          setOpen={setIsCheckCanvasCourseOpen}
          data={selectedCompetency}
        />
      )}
      {isAORequestsOpen && (
        <AORequestsModal
          open={isAORequestsOpen}
          onClose={() => setIsAORequestsOpen(false)}
        />
      )}
      <div style={{position: 'absolute', top: -42, left : 500, zIndex:1000}}>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', position: 'relative', marginBottom: 16 }}>
          <div style={{ position: 'relative', top: 0, left: 0 }}>
            <CompetencyVersionSelect
              option={versionOption}
              onChange={(v: any) => {
                setVersion(v.value);
                setVersionName(v.label);
              }}
            ></CompetencyVersionSelect>
          </div>
          <Button
            variant="contained"
            sx={{
              background: 'linear-gradient(135deg, #d97706, #b45309)',
              color: '#fff',
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: 2,
              fontSize: '13px',
              '&:hover': { background: 'linear-gradient(135deg, #b45309, #92400e)' },
            }}
            onClick={() => setIsAORequestsOpen(true)}
          >
            View AO Requests
          </Button>
        </div>
      </div>
      <CustomRow
        wrap="nowrap"
        style={{ marginLeft: "-12px", marginRight: "-10px" }}
      >
        <Col style={{ padding: 0 }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <TableComponent aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        fontWeight: "bold",
                        borderBottom: "1px solid #3C406C",
                      }}
                    >
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedVersion !== 0 ? (
                  filteredCompetencies.length === 0 ? (
                    <StyledTableRow role="checkbox" tabIndex={-1} key={0}>
                      <StyledTableCell colSpan={5} key={1} align="center">
                        No competencies are available for the selected
                        curriculum version{" "}
                        <span style={{ color: "yellow" }}>
                          ({selectedVersionName})
                        </span>
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    <>
                      {filteredCompetencies.map((row, index) => (
                        <StyledTableRow
                          onClick={() => {
                            setSelectedCompetency(row);
                            setIsModalOpen(true);
                          }}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                        >
                          {columns.map((column) => {
                            const value = row[column.id];
                            if (column.id === "evaluation") {
                              return (
                                <StyledTableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    sx={{
                                      backgroundColor: _theme.color.blue,
                                      color: _theme.color.buttonText,
                                      textTransform: "none",
                                      '&:hover': { backgroundColor: darken(0.05, _theme.color.blue) },
                                    }}
                                    startIcon={
                                      <Icon
                                      sx={{ color: "yellow", padding: "6px" }}
                                      >
                                        star_icon
                                      </Icon>
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedCompetency(row);
                                      setIsEvaluationOpen(true);
                                    }}
                                  >
                                    View Evaluation
                                  </Button>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      backgroundColor: _theme.color.blue,
                                      color: _theme.color.buttonText,
                                      textTransform: "none",
                                      '&:hover': { backgroundColor: darken(0.05, _theme.color.blue) }
                                    }}
                                    startIcon={
                                      <Icon
                                      sx={{ color: "yellow", padding: "6px" }}
                                      >
                                        check_circle
                                      </Icon>
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedCompetency(row);
                                      setIsCheckCanvasCourseOpen(true);
                                    }}
                                  >
                                    Check Canvas
                                  </Button>
                                </StyledTableCell>
                              );
                            }else {
                              return (
                                <StyledTableCell
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </StyledTableCell>
                              );
                            }
                          })}
                        </StyledTableRow>
                      ))}
                    </>
                  )
                ) : competencies.length === 0 ? (
                  <StyledTableRow role="checkbox" tabIndex={-1} key={0}>
                    <StyledTableCell colSpan={5} key={1} align="center">
                      No competencies found
                    </StyledTableCell>
                  </StyledTableRow>
                ) : (
                  <>
                    {competencies.map((row, index) => (
                      <StyledTableRow
                        onClick={() => {
                          setSelectedCompetency(row);
                          setIsModalOpen(true);
                        }}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          if (column.id === "evaluation") {
                            return (
                              <StyledTableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  sx={{
                                    backgroundColor: _theme.color.blue,
                                    color: _theme.color.buttonText,
                                    textTransform: "none",
                                    '&:hover': { backgroundColor: darken(0.05, _theme.color.blue) }
                                  }}
                                  startIcon={
                                    <Icon
                                    sx={{ color: "yellow", padding: "6px" }}
                                    >
                                      star_icon
                                    </Icon>
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedCompetency(row);
                                    setIsEvaluationOpen(true);
                                  }}
                                >
                                  View Evaluation
                                </Button>
                                <Button
                                  variant="contained"
                                  sx={{
                                    backgroundColor: _theme.color.blue,
                                    color: _theme.color.buttonText,
                                    textTransform: "none",
                                    '&:hover': { backgroundColor: darken(0.05, _theme.color.blue) }
                                  }}
                                  startIcon={
                                    <Icon
                                    sx={{ color: "yellow", padding: "6px" }}
                                    >
                                      check_circle
                                    </Icon>
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedCompetency(row);
                                    setIsCheckCanvasCourseOpen(true);
                                  }}
                                >
                                  Check Canvas
                                </Button>
                              </StyledTableCell>
                            );
                          }
                           else {
                            return (
                              <StyledTableCell
                                key={column.id}
                                align={column.align}
                              >
                                {column.format && typeof value === "number"
                                  ? column.format(value)
                                  : value}
                              </StyledTableCell>
                            );
                          }
                        })}
                      </StyledTableRow>
                    ))}
                  </>
                )}
              </TableBody>
            </TableComponent>
          )}
        </Col>
      </CustomRow>
    </>
  );
}
export default InstructorQuestsPage;
